import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/ProjectDetail.css";
import Construction1 from "../../assets/all-images/slider-img/construction-1.jpg";
import Construction2 from "../../assets/all-images/slider-img/construction-2.jpg";
import Construction3 from "../../assets/all-images/slider-img/construction-3.jpg";
import Construction4 from "../../assets/all-images/slider-img/construction-4.jpg";

const ProjectDetail = () => {
  const t = useTranslation();

 const projects = [
    {
      id: 1,
      titleKey: "projects.project1.title",
      locationKey: "projects.project1.location",
      descriptionKey: "projects.project1.description",
      image: Construction1,
      stats: {
        area: "45,000 m²",
        duration: "24 months",
        status: "Completed"
      }
    },
    // {
    //   id: 2,
    //   titleKey: "projects.project2.title",
    //   locationKey: "projects.project2.location",
    //   descriptionKey: "projects.project2.description",
    //   image: Construction2,
    //   stats: {
    //     area: "32,000 m²",
    //     duration: "18 months",
    //     status: "In Progress"
    //   }
    // },
    {
      id: 2,
      titleKey: "projects.project3.title",
      locationKey: "projects.project3.location",
      descriptionKey: "projects.project3.description",
      image: Construction2,
      stats: {
        area: "28,500 m²",
        duration: "22 months",
        status: "Completed"
      }
    },
    {
      id: 3,
      titleKey: "projects.project4.title",
      locationKey: "projects.project4.location",
      descriptionKey: "projects.project4.description",
      image: Construction3,
      stats: {
        area: "38,000 m²",
        duration: "30 months",
        status: "In Progress"
      }
    },
    {
      id: 4,
      titleKey: "projects.project5.title",
      locationKey: "projects.project5.location",
      descriptionKey: "projects.project5.description",
      image: Construction4,
      stats: {
        area: "15,000 m²",
        duration: "12 months",
        status: "Completed"
      }
    },
  ];

  return (
    <section className="projects-section" id="projects">
      <Container>
        <Row className="mb-5">
          <Col lg="12" className="text-center mb-5">
          <h6 className="section__subtitle">{t("projects.subtitle")}</h6>
            {/* <h2 className="section__title">{t("projects.title")}</h2> */}
            {/* <p className="section__description">{t("projects.description")}</p> */}
          </Col>
        </Row>

        <Row className="g-4">
          {projects.map((project) => (
            <Col lg="4" md="6" sm="12" key={project.id}>
              <div className="project__card">
                <div className="project__img-wrapper">
                  <img
                    src={project.image}
                    alt={t(project.titleKey)}
                    className="project__img"
                  />
                  {/* <div className="project__overlay">
                    <span className="project__status-badge">
                      {project.stats.status}
                    </span>
                  </div> */}
                </div>

                <div className="project__content">
                  <div className="project__header">
                    <h3 className="project__title">{t(project.titleKey)}</h3>
                    <p className="project__location">
                      <i className="ri-map-pin-fill"></i> {t(project.locationKey)}
                    </p>
                  </div>
                  
                  {/* <p className="project__description">
                    {t(project.descriptionKey)}
                  </p> */}

                  {/* <div className="project__stats">
                    <div className="stat__item">
                      <i className="ri-ruler-line"></i>
                      <span>{project.stats.area}</span>
                    </div>
                    <div className="stat__item">
                      <i className="ri-calendar-line"></i>
                      <span>{project.stats.duration}</span>
                    </div>
                  </div> */}

                  {/* <button className="project__btn">
                    View Details <i className="ri-arrow-right-line"></i>
                  </button> */}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* <Row>
          <Col lg="12" className="text-center mt-5">
            <button className="primary__btn btn__animate">
              {t("projects.viewAllButton")}
              <i className="ri-arrow-right-line"></i>
            </button>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
};

export default ProjectDetail;